<template>
  <el-image
    :src="currentSrc"
    :fit="fit"
    :preview-src-list="previewSrcList"
    @error="onError"
    @load="onLoad">
    <div slot="error">
      <ImageRefresh
        v-if="stage === 'refresh'"
        :url="lastSrc"
        @exhausted="stage = 'error'" />
      <ImageError
        v-else-if="stage === 'error'"
        :compact="compactError" />
    </div>
  </el-image>
</template>

<script>
import ImageRefresh from "./ImageRefresh";
import ImageError from "./ImageError";
import { rememberPhotoUrl } from "../../lib/photo-url-cache";

// Ảnh đi qua 3 chặng: thử lần lượt từng link trong `sources` (link 404 tụt xuống link kế),
// hết link -> ImageRefresh (cache-bust retry), vẫn hỏng -> ImageError.
// Vẫn dùng el-image làm gốc để giữ nguyên lightbox sẵn có qua preview-src-list.
export default {
  name: "PhotoImage",
  components: { ImageRefresh, ImageError },
  props: {
    // Chuỗi link ứng viên, đã qua getCloudUrl + toDisplayableImageUrl.
    sources: { type: Array, default: () => [] },
    previewSrcList: { type: Array, default: () => [] },
    fit: { type: String, default: "cover" },
    // msgId của ảnh - dùng để nhớ link tải được cho lightbox.
    cacheKey: { type: String, default: "" },
    compactError: { type: Boolean, default: false }
  },
  data() {
    return {
      index: 0,
      stage: "img"
    };
  },
  computed: {
    urls() {
      return (this.sources || []).filter(u => typeof u === "string" && u).filter((u, i, a) => a.indexOf(u) === i);
    },
    currentSrc() {
      return this.urls[this.index] || "";
    },
    lastSrc() {
      return this.urls[this.urls.length - 1] || "";
    }
  },
  watch: {
    urls: {
      immediate: true,
      handler(list) {
        this.index = 0;
        this.stage = list.length ? "img" : "error";
      }
    }
  },
  methods: {
    onLoad() {
      rememberPhotoUrl(this.cacheKey, this.currentSrc);
    },
    onError() {
      if (this.index < this.urls.length - 1) {
        this.index++;
        return;
      }
      if (this.stage === "img") this.stage = "refresh";
    }
  }
};
</script>

<style scoped>

</style>
